(function ($, Drupal, once) {

  'use strict';

  Drupal.behaviors.facetClick = {
    attach: function attach(context, settings) {
      // Triggers a click on the actual facet to let the
      // actual facet module JS do the adding & removal of filters.
      once('facetClick', '.facet-item > a:first-child', context).forEach(function (element) {
        jQuery(element).click(function (e) {
          if (!jQuery(this).attr('data-facet-filter').includes(jQuery(this).attr('href'))) {
            jQuery(this).attr('data-facet-filter', jQuery(this).attr('href') + "?" + jQuery(this).attr('data-facet-filter'));
          }
        });
      });
    }
  };
})(jQuery, Drupal, once);
